import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ApiCore } from '../../api';
import { Picker, List, ActivityIndicator, ListView, PullToRefresh } from 'antd-mobile';
import moment from 'moment';
import styles from './paySheet.module.scss';
import labor_pay from '../../static/images/labor_pay.png';
import no_pay_sheet_record  from '../../static/images/no_pay_sheet_record.png'
import right_arrow from '../../static/images/rightArrow.png';

const api = new ApiCore();

function LaborService(props: any) {

    const [list, setList] = useState([]);
    //项目list
    const [projectList, setProjectList] = useState([]);
    //项目加载对应类型映射
    const [projectTypeMap, setProjectTypeMap] = useState({});
    //选择的项目
    const [selectProject, setSelectProject] = useState<any>([]);
    //选择的项目名称
    const [selectProjectName, setSelectProjectName] = useState<any>('全部项目');
    //年份列表
    const [yearList, setYearList] = useState<any>([]);
    //选择的年份
    const [selectYear, setSelectYear] = useState<any>([]);
    //选择的年份名称
    const [selectYearName, setSelectYearName] = useState<any>('');
    //设置加载状态
    const [loading, setLoading] = useState<any>(null);
    // 上拉加载与下拉刷新
    const [isPullToRefresh, setIsPullToRefresh] = useState<boolean>(false); // 下拉刷新状态
    const [isMore, setIsMore] = useState<boolean>(true); // 是否还有更多数据
    const [curPage, setCurPage] = useState<number>(1); // 当前加载的页数
    const [curPageSize, setCurPageSize] = useState<number>(10); // 分页条数
    const [total, setTotal] = useState<number>(10); // 总条数
    const [listLoading, setListLoading] = useState(false);
    useEffect(() => {
        document.title = '我的结算单';
        initYearsList();
        getProjectList();
        getLaborAgreement();
        return () => {
        }
    }, []);

    const initYearsList = () => {
        const thisYear = (new Date()).getFullYear();
        setSelectYear([thisYear]);
        setSelectYearName(thisYear + '年');
        const yearItems = [];
        const count = 100;
        yearItems.push({
            label: '所有年份',
            value: 'All'
        });
        for (let i = 0 ; i <= count; i++) {
            const itemYear = (thisYear - i);
            yearItems.push({
                label: itemYear + '年',
                value: itemYear
            });
        }
        setYearList(yearItems);
    }

    const getProjectList = () => {
        //获取用户的项目列表
        api.getProject().then(res => {
            if (res.code == '0' && res.data.length > 0) {
                let filterArr: any = [
                    {
                        label: '全部项目',
                        value: null
                    }
                ];
                const _projectMap = { null: '' };
                for (let item of res.data) {
                    _projectMap[item.code] = item;
                    filterArr.push(
                        {
                            label: item.name,
                            value: item.code
                        }
                    )
                }
                setProjectList(filterArr);
                setProjectTypeMap(_projectMap);
            }
        })
    }

    const getLaborAgreement = (projectCode = '', nowYear = '') => {
        setLoading(true);
        let thisYear = '';
        let thisMoment = '';
        if (nowYear == 'All') {
            thisYear = '';
            thisMoment = '';
        } else if (nowYear) {
            thisYear = nowYear + '-01-01T00:00:00';
            thisMoment = nowYear + '-12-31T23:59:59';
        } else {
            thisYear = (new Date()).getFullYear() + '-01-01T00:00:00';
            thisMoment = moment(new Date()).format('YYYY-MM-DD') + 'T23:59:59';
        }
        setCurPage(1);
        api.getPaySheetList({
            page: 1,
            pageSize: 10,
            startTime: thisYear,
            endTime: thisMoment,
            projectCode: projectCode
            // page?: number,
            // pageSize?: number
         }).then((res: any) => {
            if (res.code == 0) {
                setList(res.data.rows || []);
                setLoading(false);
                if (res.data && res.data.total >= 0) {
                    setTotal(res.data.total);
                }
            }
        })
    }

    //当选了项目
    const onProjectOk = (value: any) => {
        setSelectProject(value);
        let projectCode = value[0];
        let year = (selectYear && selectYear[0]) || '';
        getLaborAgreement(projectCode, year);
    }

    //当选了项目
    const onYearOk = (value: any) => {
        setSelectYear(value);
        let projectCode = (selectProject && selectProject[0]) || '';
        // @ts-ignore
        getLaborAgreement(projectCode, value[0]);
    }

    const itemClick = (item: any) => {
        sessionStorage.setItem('doctor_pay_sheet_item', JSON.stringify(item));
        let _preSignUrl = `?needView=${item.viewFlag}`;
        props.history.push('/doctor/paySheetDetail' + _preSignUrl);
    }

    // 下拉加载
    const onPullToRefresh = () => {
        setIsPullToRefresh(true);
        setIsMore(true);
        // 重置状态
        setLoading(true);
        setCurPage(1);
        setListLoading(true);
        let _selectYear = selectYear;
        let thisYear = '';
        let thisMoment = '';
        if (_selectYear == 'All') {
            thisYear = '';
            thisMoment = '';
        } else {
            thisYear = _selectYear + '-01-01T00:00:00';
            thisMoment = _selectYear + '-12-31T23:59:59';
        }
        let _projectCode = (selectProject && selectProject[0]) || '';
        api.getPaySheetList({
            page: 1,
            pageSize: 10,
            startTime: thisYear,
            endTime: thisMoment,
            projectCode: _projectCode
        }).then((res: any) => {
            if (res.code == 0) {
                let _list = (res.data && res.data.rows) || [];
                if (res.code == 0) {
                    setList(_list);
                    setTotal(res.data.total);
                }
                setLoading(false);
                setIsPullToRefresh(false);
                setListLoading(false);
            }
        })
    }
        
    // 触底上拉刷新
    const onEndListAdded = () => {
        setListLoading(true);
        let nowPage = curPage;
        // 超出分页总数据后不再加载
        if (nowPage * curPageSize > total) {
            setIsMore(false);
            setListLoading(false);
            return;
        }
        nowPage++;
        setCurPage(nowPage);
        let _selectYear = selectYear;
        let thisYear = '';
        let thisMoment = '';
        if (_selectYear == 'All') {
            thisYear = '';
            thisMoment = '';
        } else {
            thisYear = _selectYear + '-01-01T00:00:00';
            thisMoment = _selectYear + '-12-31T23:59:59';
        }
        let _projectCode = (selectProject && selectProject[0]) || ''
        api.getPaySheetList({
            page: nowPage,
            pageSize: 10,
            startTime: thisYear,
            endTime: thisMoment,
            projectCode: _projectCode
        }).then((res: any) => {
            setTimeout(() => {
                setListLoading(false);
                if (res.code == 0) {
                    setList(list.concat(res.data && res.data.rows) || []);
                    setTotal(res.data.total);
                }
                setIsPullToRefresh(false);
            }, 375);
        });
    }
        
    // 上拉触底
    const onEndReached = () => {
        if (isMore) {
            //加载数据
            onEndListAdded()
        }
    }
        
    const dataView = new ListView.DataSource({
        rowHasChanged: (row1: any, row2: any) => row1 !== row2,
    });

    const dataSource = dataView.cloneWithRows(list);

    const row = (val: any, index: any) => (
        <div className={styles.list_item} key={index} onClick={() => { itemClick(val)} }>
        <div className={styles.item_head}>
            <div className={styles.head_left}>
                接收日期：<span>{val.createTime ? val.createTime.replace('T', ' ') : ''}</span>
            </div>
            {/* <div className={`${styles.head_right}  ${val.status == 1 ? styles.sign : styles.no_sign}`}>{ val.status == 1 ? '已签署' : '未签署'}</div> */}
        </div>
        <div className={styles.item_body}>
            <img className={styles.service_icon} src={`${labor_pay}`} alt="" />
            <div className={`${styles.body_text} ${val.viewFlag ? styles.text_need_read : ''}`}>
                {val.title}
            </div>
            <img className={styles.right_icon} src={right_arrow} alt="" />
        </div>
    </div>
    );

    return (
        <div className={styles.paySheet_content}>
            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
            <div className={styles.head_select}>
                <div>

                        <Picker data={projectList} title='选择项目' extra={selectProjectName} cols={1} onOk={onProjectOk} value={selectProject}>
                            <List.Item arrow="down"></List.Item>
                        </Picker>
                        {/* <span>全部项目</span> */}
                    {/* <img src={select_arrow_down} alt="全部项目" /> */}
                </div>
                <div>
                        <Picker data={yearList} title='' extra={selectYearName} cols={1} onOk={onYearOk} value={selectYear}>
                            <List.Item arrow="down"></List.Item>
                        </Picker>
                    {/* <span>所有状态</span>
                    <img src={select_arrow_down} alt="所有状态" /> */}
                </div>
            </div>
            {
                loading === false &&
                <div className={styles.list_content}>
                    {
                        (list && list.length > 0) && 
                        <ListView
                            style={{ height: 'calc(100vh - 1.2rem)' }}
                            className={styles.listview}
                            dataSource={dataSource}
                            renderRow={row}
                            initialListSize={2000}
                            onEndReached={onEndReached}
                            onEndReachedThreshold={6}
                            scrollRenderAheadDistance={500}
                            scrollEventThrottle={200}
                            useBodyScroll={false}
                            pullToRefresh={
                                <PullToRefresh
                                    damping={60}
                                    distanceToRefresh={25}
                                    indicator={{}}
                                    direction="down"
                                    refreshing={isPullToRefresh}
                                    getScrollContainer={() => undefined}
                                    onRefresh={() => {
                                        onPullToRefresh()
                                    }}
                                >
                                </PullToRefresh>
                            }
                            renderFooter={() => (
                            <div style={{ padding: '12.5px 0 12px 0', marginBottom: '0px', textAlign: 'center' }}>
                                {listLoading ? '正在加载...' : '没有更多'}
                            </div>)}
                        />
                    }   
                    {
                       false && list && list.map((val: any, index) => {
                            return (
                            <div className={styles.list_item} key={index} onClick={() => { itemClick(val)} }>
                                <div className={styles.item_head}>
                                    <div className={styles.head_left}>
                                        接收日期：<span>{val.createTime ? val.createTime.replace('T', ' ') : ''}</span>
                                    </div>
                                    {/* <div className={`${styles.head_right}  ${val.status == 1 ? styles.sign : styles.no_sign}`}>{ val.status == 1 ? '已签署' : '未签署'}</div> */}
                                </div>
                                <div className={styles.item_body}>
                                    <img className={styles.service_icon} src={`${labor_pay}`} alt="" />
                                    <div className={`${styles.body_text} ${val.viewFlag ? styles.text_need_read : ''}`}>
                                        {val.title}
                                    </div>
                                    <img className={styles.right_icon} src={right_arrow} alt="" />
                                </div>
                            </div>)
                        })
                    }
                    {
                      (list && list.length === 0) && 
                        <div className={styles.list_no_item} >
                            <img src={no_pay_sheet_record} alt="" />
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default withRouter(LaborService);